import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import CustomerPortal from "@/pages/CustomerPortal";
import CustomerPinDetail from "@/pages/CustomerPinDetail";
import Dashboard from "@/pages/Dashboard";
import TagDetail from "@/pages/TagDetail";
import Internal from "@/pages/Internal";
import Inventory from "@/pages/Inventory";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminCodeAnalytics from "@/pages/AdminCodeAnalytics";
import AdminAdmins from "@/pages/AdminAdmins";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <span className="font-mono text-sm text-primary animate-pulse" data-testid="auth-loading">INITIALIZING…</span>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  return user ? children : <Navigate to="/login" replace />;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/internal" element={<Internal />} />
            <Route path="/" element={<Protected><CustomerPortal /></Protected>} />
            <Route path="/pin/:code" element={<Protected><CustomerPinDetail /></Protected>} />
            <Route path="/admin" element={<AdminOnly><Dashboard /></AdminOnly>} />
            <Route path="/admin/inventory" element={<AdminOnly><Inventory /></AdminOnly>} />
            <Route path="/admin/customers" element={<AdminOnly><AdminCustomers /></AdminOnly>} />
            <Route path="/admin/admins" element={<AdminOnly><AdminAdmins /></AdminOnly>} />
            <Route path="/admin/code/:code" element={<AdminOnly><AdminCodeAnalytics /></AdminOnly>} />
            <Route path="/admin/tags/:id" element={<AdminOnly><TagDetail /></AdminOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
